import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const Key = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9979 7.36989C12.4807 7.36989 13.6828 6.1678 13.6828 4.68495C13.6828 3.20209 12.4807 2 10.9979 2C9.51503 2 8.31294 3.20209 8.31294 4.68495C8.31294 5.15493 8.4337 5.59672 8.64588 5.98096L2.52127 12.1056C2.2491 12.3778 2.2491 12.819 2.52127 13.0912C2.79344 13.3634 3.23471 13.3634 3.50688 13.0912L3.84692 12.7512L4.81141 13.659C5.30699 14.1255 6.08412 14.1117 6.56286 13.628L7.52389 12.6569C8.0029 12.1729 8.00832 11.3952 7.53609 10.9045L6.63242 9.96566L9.61265 6.98542C10.0171 7.22947 10.4911 7.36989 10.9979 7.36989ZM10.9979 5.97602C11.7109 5.97602 12.289 5.39799 12.289 4.68495C12.289 3.9719 11.7109 3.39387 10.9979 3.39387C10.2848 3.39387 9.70681 3.9719 9.70681 4.68495C9.70681 5.39799 10.2848 5.97602 10.9979 5.97602ZM5.64663 10.9514L4.83298 11.7651L5.66778 12.5509L6.43749 11.7731L5.64663 10.9514Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default Key;
